import { render } from "./UploadArea.vue?vue&type=template&id=6707fb55&scoped=true&ts=true"
import script from "./UploadArea.vue?vue&type=script&lang=ts"
export * from "./UploadArea.vue?vue&type=script&lang=ts"

import "./UploadArea.vue?vue&type=style&index=0&id=6707fb55&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6707fb55"]])

export default __exports__